export const FOOD_ACCESS_CONFIDENCE_FILTERS = Object.freeze({
  ALL: "all",
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
  NEEDS_REVIEW: "needs_review",
});

export const FOOD_ACCESS_CONFIDENCE_FILTER_OPTIONS = [
  { value: FOOD_ACCESS_CONFIDENCE_FILTERS.ALL, label: "All confidence levels" },
  { value: FOOD_ACCESS_CONFIDENCE_FILTERS.HIGH, label: "High confidence" },
  { value: FOOD_ACCESS_CONFIDENCE_FILTERS.MEDIUM, label: "Medium confidence" },
  { value: FOOD_ACCESS_CONFIDENCE_FILTERS.LOW, label: "Low confidence" },
  { value: FOOD_ACCESS_CONFIDENCE_FILTERS.NEEDS_REVIEW, label: "Needs review" },
];

export const FOOD_ACCESS_CONFIDENCE_LABELS = Object.freeze({
  HIGH_CONFIDENCE: "HIGH_CONFIDENCE",
  MEDIUM_CONFIDENCE: "MEDIUM_CONFIDENCE",
  LOW_CONFIDENCE: "LOW_CONFIDENCE",
  NEEDS_REVIEW: "NEEDS_REVIEW",
  UNTRUSTED: "UNTRUSTED",
});

export function confidenceFilterMatchesFeature(filter, properties = {}) {
  if (!filter || filter === FOOD_ACCESS_CONFIDENCE_FILTERS.ALL) return true;
  const label = properties.confidenceLabel;
  if (!label) return filter !== FOOD_ACCESS_CONFIDENCE_FILTERS.NEEDS_REVIEW;
  switch (filter) {
    case FOOD_ACCESS_CONFIDENCE_FILTERS.HIGH:
      return label === FOOD_ACCESS_CONFIDENCE_LABELS.HIGH_CONFIDENCE;
    case FOOD_ACCESS_CONFIDENCE_FILTERS.MEDIUM:
      return label === FOOD_ACCESS_CONFIDENCE_LABELS.MEDIUM_CONFIDENCE;
    case FOOD_ACCESS_CONFIDENCE_FILTERS.LOW:
      return label === FOOD_ACCESS_CONFIDENCE_LABELS.LOW_CONFIDENCE;
    case FOOD_ACCESS_CONFIDENCE_FILTERS.NEEDS_REVIEW:
      return label === FOOD_ACCESS_CONFIDENCE_LABELS.NEEDS_REVIEW;
    case "untrusted":
      return label === FOOD_ACCESS_CONFIDENCE_LABELS.UNTRUSTED;
    default:
      return true;
  }
}

export function confidenceBadgeClass(label) {
  switch (label) {
    case FOOD_ACCESS_CONFIDENCE_LABELS.HIGH_CONFIDENCE:
      return "badge badge--success";
    case FOOD_ACCESS_CONFIDENCE_LABELS.MEDIUM_CONFIDENCE:
      return "badge badge--info";
    case FOOD_ACCESS_CONFIDENCE_LABELS.LOW_CONFIDENCE:
      return "badge badge--warning";
    case FOOD_ACCESS_CONFIDENCE_LABELS.NEEDS_REVIEW:
      return "badge badge--caution";
    case FOOD_ACCESS_CONFIDENCE_LABELS.UNTRUSTED:
      return "badge badge--danger";
    default:
      return "badge";
  }
}
